async function handleLogInEvent() {}

async function handleLogOutEvent() {}

export default {
  handleLogInEvent,
  handleLogOutEvent
}
